import { useQueryClient } from "@tanstack/react-query";
import React, { useEffect } from "react";
import carImage from "../../assets/car.png";
import { Icon } from "../../assets/icons";
import logo from "../../assets/logo.png";
import { Button } from "../../components/Button";
import { Checkbox } from "../../components/Checkbox";
import { Input } from "../../components/Input";
import "../../index.css";
import { useLogin } from "./hooks";

const Login: React.FC = () => {
  const { register, errors, onSubmit, isLoading, navigate, watch } = useLogin();

  const queryClient = useQueryClient();
  // Clear all data in react-query to prevent stale data showing after logout
  useEffect(() => {
    queryClient.clear();
  }, []);

  return (
    <div className="login-page" style={{ fontFamily: "Public Sans" }}>
      <div className="flex min-h-screen max-h-screen overflow-hidden">
        <div className="flex-1 relative overflow-hidden min-w-0">
          <div
            className="w-full h-screen bg-cover bg-no-repeat bg-center bg-fixed transform-gpu backface-hidden"
            style={{ backgroundImage: `url(${carImage})` }}
          >
            {/* Car image will be handled by CSS background */}
          </div>
        </div>

        <div className="flex-1 bg-black flex flex-col items-center justify-center p-10 relative min-w-0 h-screen overflow-y-auto">
          <div className="w-full max-w-sm text-white relative z-10 flex-1 flex flex-col justify-center">
            <div className="text-center mb-10">
              <img
                src={logo}
                alt="TCTC Logo"
                className="h-20 w-auto max-w-[200px] object-contain mx-auto"
              />
            </div>
            <form noValidate onSubmit={onSubmit} className="w-full">
              <div className="mb-6">
                <Input
                  label="メールアドレス"
                  placeholder="メールアドレス"
                  error={errors.email?.message}
                  {...register("email")}
                  disabled={isLoading}
                  labelBgClass="!bg-black !text-auro_metal_saurus"
                  className="!border-gray-700 !bg-black !text-white !text-base focus:!border-blue-500 placeholder:!text-gray-700"
                />
              </div>

              <div className="mb-6">
                <Input
                  type={"password"}
                  label="パスワード"
                  placeholder="パスワード"
                  error={errors.password?.message}
                  {...register("password")}
                  disabled={isLoading}
                  labelBgClass="!bg-black !text-auro_metal_saurus"
                  className="!border-gray-700 !bg-black !text-white !text-base focus:!border-blue-500 placeholder:!text-gray-700 !pr-10"
                />
              </div>

              <div className="flex justify-between items-center mb-8 text-sm">
                <label className="flex items-center cursor-pointer text-gray-300">
                  <Checkbox
                    type="dark"
                    {...register("rememberMe")}
                    checked={watch("rememberMe")}
                    disabled={isLoading}
                  />
                  <span className="ml-2 text-white">
                    ログイン状態を維持する
                  </span>
                </label>

                <Button
                  type="button"
                  buttonType="link"
                  className="!text-white underline font-normal !bg-transparent !border-none !p-0 !text-sm !cursor-pointer hover:!text-white hover:!underline"
                  onClick={() => navigate("/forgot-password")}
                >
                  パスワード忘れ
                </Button>
              </div>

              <Button
                type="submit"
                buttonType="primary"
                className="w-full !text-base !p-3 !h-[50px] !mb-6 !mx-auto !block !relative !overflow-hidden"
                disabled={isLoading}
                isLoading={false}
              >
                <span className="flex items-center justify-center w-full h-full font-semibold text-base tracking-wide relative">
                  {isLoading && (
                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 flex items-center z-[2] pointer-events-none">
                      <Icon
                        name="loading"
                        width="20"
                        height="20"
                        color="white"
                        className="animate-spin"
                      />
                    </span>
                  )}
                  <span className="w-full text-center text-[15px]">
                    ログイン
                  </span>
                </span>
              </Button>
            </form>
          </div>

          <div className="text-center text-xs text-gray-500 leading-tight whitespace-nowrap w-full max-w-[450px] mt-5">
            Copyright © The Japan Automobile Tyre Manufacturers Association,
            Inc. All rights reserved
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
